import { combineReducers } from 'redux';

import {
} from '../constants/checkoutAccordionConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const confirms = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const showPriceRange = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const useDefaultTheme = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const checkoutAccordionReducer = combineReducers({
  csrfToken,
  team,
  confirms,
  showPriceRange,
  useDefaultTheme
});

export default checkoutAccordionReducer;
